export enum OffersTypes {
  SAVE_OFFER = 'SAVE_OFFER',
  SAVE_OFFERS = 'SAVE_OFFERS',
  EDIT_OFFER = 'EDIT_OFFER',
  REMOVE_OFFER = 'REMOVE_OFFER'
}
